import { useIsOmniAnalyticsConfiguredQuery } from './requests/omni.gql.generated';

/**
 * Whether the org has Omni analytics configured (an omniConfig granting at least
 * one model), for showing an Analytics nav item only where the embed would work.
 * False while loading or on error, so the item never flashes in for an org
 * without analytics.
 */
export const useIsOmniAnalyticsConfigured = (
  organizationId: string,
): boolean => {
  const { data } = useIsOmniAnalyticsConfiguredQuery({
    variables: { organizationId },
  });
  return data?.isConfigured ?? false;
};
